import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import BodyText from 'LuxKit/Typography/BodyText'
import Badge from 'LuxKit/Badge'
import FormatCurrency from 'components/Common/FormatCurrency'
import LineShoppingCartIcon from 'LuxKit/Icons/line/LineShoppingCartIcon'
import NavBarButton from 'components/NavKit/NavBarButton/NavBarButton'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import Group from 'components/utils/Group'

interface Props {
  itemCount: number
  totalPrice: number
  isLoading: boolean
  onClick: () => void
}

const StyledCartButton = styled(NavBarButton)`
  height: ${rem(38)};
  min-width: ${rem(188)};
  padding: ${rem(4)} ${rem(8)};
  border-radius: ${props => props.theme.borderRadius.round};
  border: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
  justify-content: stretch;

`

const CartLabelWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  gap: ${rem(4)};
`

const CartIconWrapper = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${rem(30)};
  height: ${rem(30)};
`

const ItemCountBadge = styled(Badge)`
  position: absolute;
  top: ${rem(-4)};
  right: ${rem(-4)};
  transform: scale(0.8203125);
  transform-origin: top right;
`

function CartButton({ itemCount, totalPrice, isLoading, onClick }: Props) {
  const intl = useIntl()

  const tripCartLabel = intl.formatMessage({
    id: '9ldY3Yc7FjrKlzu4hrig',
    defaultMessage: 'Trip cart',
    description: 'Label for the cart button in the trip planner header that opens the trip cart panel',
  })

  return (
    <StyledCartButton
      onClick={onClick}
    >
      <Group direction="horizontal" gap={8} horizontalAlign="space-between" verticalAlign="center" fullWidth>
        <CartLabelWrapper>
          <CartIconWrapper>
            <LineShoppingCartIcon size={18.75} />
            {!isLoading && <ItemCountBadge kind="string" mode="critical">{String(itemCount)}</ItemCountBadge>}
          </CartIconWrapper>
          <BodyText variant="medium">{tripCartLabel}</BodyText>
        </CartLabelWrapper>
        {isLoading && <TextLoadingBox typography="body-medium" width="10ch" />}
        {!isLoading && (
          <BodyText variant="medium" weight="bold">
            <FormatCurrency value={totalPrice} format="preciseDollar" />
          </BodyText>
        )}
      </Group>
    </StyledCartButton>
  )
}

export default CartButton
